import { render, staticRenderFns } from "./MetaDataFieldIndex.vue?vue&type=template&id=2f4c77b6&"
import script from "./MetaDataFieldIndex.vue?vue&type=script&lang=js&"
export * from "./MetaDataFieldIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports